export default __webpack_public_path__ + "static/media/ic-assignment.d7fd8403.svg";